export const colors = {
  primary: "#8bc34a",
  primaryLight: "#bef67a",
  primaryDark: "#5a9216",
  secondary: "#ef6c00",
  secondaryLight: "#ff9d3f",
  secondaryDark: "#b53d00"
};
